import { ITripRequestLogSchema } from './trip-request-log-schema.interface';
import { TripRequestLogSource } from '../../enums/trip-request-log-source.enum';
import { TripRequestLogStatus } from '../../enums/trip-request-log-status.enum';

export interface IGroupedTripRequestLogSchema {
    tripCode: string;
    tripDefinitionName?: string;
    lastTimestamp: string;
    status: TripRequestLogStatus;
    requestsCount: number;
    successRequestsCount: number;
    failedRequestsCount: number;
    userName?: string;
    apiKey?: string;
    source?: TripRequestLogSource;
    requests: ITripRequestLogSchema[];
}
